// // for GET apis 
// export const BASE_URL = "https://wpr.intertoons.net/hrmsdevapi/?sp="

// // for POST apis 
// export const BASE_URL_TWO = "https://wpr.intertoons.net/hrmsdevapi/"

// for GET apis 
export const BASE_URL = "https://wpr.intertoons.net/hrmsapi/?sp="

// for POST apis 
export const BASE_URL_TWO = "https://wpr.intertoons.net/hrmsapi/"